<template>
  <FusionBaseDialog
    :open="open"
    :title="$t('dashboard.removeWarningDialog.title')"
    icon="mdi-alert"
    :maxWidth="450"
    persistentOverlay
    padded
    content-class="removeWarning"
    data-cy="removeWarningDialog"
  >
    {{ $t('dashboard.removeWarningDialog.message') }}
    <template v-slot:actions>
      <v-btn
        @click="cancel"
        variant="outlined"
        class="text-black dialog-btn"
        data-cy="removeWidgetCancel"
      >
        {{ $t('buttons.cancel') }}
      </v-btn>
      <v-spacer />
      <v-btn
        @click="remove"
        variant="text"
        class="bg-primary text-white dialog-btn"
        data-cy="removeWidgetOK"
      >
        {{ $t('dashboard.removeWarningDialog.removeButton') }}
      </v-btn>
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDisplay } from 'vuetify'

export default defineComponent({
  name: 'RemoveWarningDialog',
  setup() {
    const { xs } = useDisplay()
    return { xs }
  },
  props: ['open'],
  emits: ['ok', 'cancel'],
  methods: {
    remove() {
      this.$emit('ok')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
})
</script>
